import type { GetStatusRequest, GetStatusResponse } from '~/api/aspida/@types';
import { sendRequest } from '~/api/sendRequest';

export const getStatus = sendRequest<GetStatusRequest, GetStatusResponse>({
  url: '/status',
  method: 'get',
});
